import React from 'react'
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material'

import TemplateInfo from 'components/TemplatePerformance/TemplateInfo';
import ShadowBox from 'components/ShadowBox';
import UsersAnalytics from 'components/TemplatePerformance/UsersAnalytics';
import ScreenHeading from 'components/ScreenHeading';
import LeaderBoard from 'components/Analytics/LeaderBoard';
import ScoreDistributionChart from 'components/Analytics/ScoreDistribution';
import { AttemptRateChart } from 'components/Analytics/ScoreDistribution';
import { getAverageAttemptRateDetails } from 'services/analyticsV2';
import { getUserCodeDetailById } from 'services/userCodeDetails';
import { WhiteBox } from 'components/AppShell';
import { getLeaderboard, getInterviewDetails } from 'services/analyticsV2';

const PersonalizedCodingPerformance = () => {
    const { id } = useParams();

    const [template, setTemplate] = React.useState({});
    const [interviewDetails, setInterviewDetails] = React.useState({});
    const [interviewDetailsLoading, setInterviewDetailsLoading] = React.useState(true);
    const [interviewDetailsError, setInterviewDetailsError] = React.useState(null);
    const [leaderboardData, setLeaderboardData] = React.useState({ topPerformers: [], bestPerformers: [] });
    const [leaderboardLoading, setLeaderboardLoading] = React.useState(true);
    const [leaderboardError, setLeaderboardError] = React.useState(null);
    const [leaderboardCategory, setLeaderboardCategory] = React.useState('best_score');
    const [attemptRateData, setAttemptRateData] = React.useState(null);
    const [attemptRateLoading, setAttemptRateLoading] = React.useState(true);
    const [attemptRateError, setAttemptRateError] = React.useState(null);
  
    React.useEffect(() => {
      getUserCodeDetailById(id)
        .then(({ templates }) => {
          const matchingTemplate = templates.find(template => template._id === id);
          if (matchingTemplate) {
            setTemplate(matchingTemplate); 
          } else {
            console.error(`Template with id ${id} not found`);
          }
        })
        .catch(console.error);
    }, [id]);

    React.useEffect(() => {
      if (!id) return;
      setLeaderboardLoading(true);
      setLeaderboardError(null);
      getLeaderboard({ type: 'interview', id, interviewVariantType: 'coding_mock', leaderboardType: leaderboardCategory })
        .then(response => setLeaderboardData(response || { topPerformers: [], bestPerformers: [] }))
        .catch(err => setLeaderboardError(err.message))
        .finally(() => setLeaderboardLoading(false));
    }, [id, leaderboardCategory]);

    React.useEffect(() => {
      if (!id) return;
      setAttemptRateLoading(true);
      setAttemptRateError(null);
      getAverageAttemptRateDetails({ type: 'interview', id, interviewVariantType: 'coding_mock' })
        .then(response => setAttemptRateData(response))
        .catch(err => setAttemptRateError(err.message))
        .finally(() => setAttemptRateLoading(false));
    }, [id]);

    React.useEffect(() => {
      if (!id) return;
      setInterviewDetailsLoading(true);
      setInterviewDetailsError(null);
      getInterviewDetails(id, 'coding_mock')
        .then(response => setInterviewDetails(response))
        .catch(err => setInterviewDetailsError(err.message))
        .finally(() => setInterviewDetailsLoading(false));
    }, [id,leaderboardCategory]);

  return (
    <Box display="flex" flexDirection="column" minHeight='calc(100vh - 76px)' gap={4}>
       <ScreenHeading title="Coding interview analytics" id="coding-analytics"></ScreenHeading>
       <TemplateInfo 
         interviewDetails={interviewDetails}
         loading={interviewDetailsLoading}
         error={interviewDetailsError}
         template={template} 
         interviewType='Coding Mock'
       />
       <Box display='flex' gap={4}>
       <WhiteBox sx={{width : '100% !important'}}>
          <LeaderBoard 
            data={leaderboardData} 
            loading={leaderboardLoading} 
            error={leaderboardError}
            interviewVariantType="coding_mock"
            leaderboardCategory={leaderboardCategory}
            setLeaderboardCategory={setLeaderboardCategory}
          />
      </WhiteBox>
      <Box display='flex' width='100%' flexDirection='column' gap={4}>
          <WhiteBox>
            <ScoreDistributionChart
             avgDistribution={{
              batchAverageScore: Math.round(attemptRateData?.averageScoreStats?.averageScore || 0)
            }}
            scoreDistribution={attemptRateData?.averageScoreStats || {"0-30": 0, "31-60": 0, "61-100": 0}}
            totalStudents={attemptRateData?.totalStudents || 0}
            loading={attemptRateLoading}
            error={attemptRateError}
            interviewVariantType="coding_mock"
            />
          </WhiteBox>
          <WhiteBox>
            <AttemptRateChart 
                attemptRate={{
                  attemptRate: attemptRateData?.attemptRateStats?.attemptRate || 0,
                  userSubmittedCount: (attemptRateData?.attemptRateStats?.["31-60"] || 0) + (attemptRateData?.attemptRateStats?.["61-100"] || 0),
                  userNotSubmittedCount: attemptRateData?.attemptRateStats?.["0-30"] || 0
                }}
                loading={attemptRateLoading}
                error={attemptRateError}
                totalStudents={attemptRateData?.totalStudents || 0}
            />
          </WhiteBox>
        </Box>
      </Box>
      <ShadowBox sx={{ mt: 0 }}>
        <UsersAnalytics
          batch={template?.batch?._id}
          template={template}
          forTemplateAnalytics={true}
          interviewType="coding_mock"
        />
      </ShadowBox>
    </Box>
  )
}

export default PersonalizedCodingPerformance;